import icon from '@plone/volto/icons/quote.svg';

import { HomepageNewsKacheln, PdfListing, ProjektKategorieListing, ProjektListing } from './customizations/components/manage/Blocks/Listing';
import { NewEditTitleBlock } from './customizations/components/manage/Blocks/Title';
import EventView from './customizations/components/theme/View/EventView';
import { NewsItemView } from './customizations/components/theme/View/NewsItemView';

// Import components for icon-grid
import IconGridEdit from './my-blocks/icon-hot-bar/Edit';
import IconGridView from './my-blocks/icon-hot-bar/View';
import iconGridIcon from '@plone/volto/icons/blog.svg';

import ButtonHighlightEdit from './my-blocks/button-highlight/Edit';
import ButtonHighlightView from './my-blocks/button-highlight/View';
import ButtonHighlightIcon from '@plone/volto/icons/finger-print.svg';

import SponsorenBereichEdit from './my-blocks/sponsoren-bereich/Edit';
import SponsorenBereichView from './my-blocks/sponsoren-bereich/View';
import SponsorenBereichIcon from '@plone/volto/icons/add-on.svg';

import SliderEdit from './my-blocks/custom-slider-block/Edit';
import SliderView from './my-blocks/custom-slider-block/View';
import SliderIcon from "@plone/volto/icons/slider.svg";

import KontakteEdit from './my-blocks/kontakte-block/Edit';
import KontakteView from './my-blocks/kontakte-block/View';
import KontakteIcon from "@plone/volto/icons/add-user.svg";

import FormularEdit from './my-blocks/formular-block/Edit';
import FormularView from './my-blocks/formular-block/View';
import FormularIcon from "@plone/volto/icons/collection.svg";

import FoerdererEdit from './my-blocks/foerderer-block/Edit';
import FoerdererView from './my-blocks/foerderer-block/View';
import FoerdererIcon from "@plone/volto/icons/group.svg";

import CalendarEdit from './my-blocks/calendar-block/Edit';
import CalendarView from './my-blocks/calendar-block/View';
import CalendarIcon from "@plone/volto/icons/calendar.svg";

export default function applyConfig(config) {
  config.settings = {
    ...config.settings,
    isMultilingual: true,
    supportedLanguages: ['de', 'en'],
    defaultLanguage: 'de',
  };

  config.blocks.requiredBlocks = [];

  config.views.contentTypesViews.Event = EventView;

  config.blocks.blocksConfig.listing.variations = [
    ...config.blocks.blocksConfig.listing.variations,
    {
      id: "HomepageNewsKacheln",
      title: "Homepage News Kacheln",
      template: HomepageNewsKacheln,
      fullobjects: true,
    },
    {
      id: "PdfListing",
      title: "PDF Liste",
      template: PdfListing,
      fullobjects: true,
    },
    {
      id: "Projekt Kategorie Listing",
      title: "Projekt Kategorie Liste",
      template: ProjektKategorieListing,
      fullobjects: true,
    },
    {
      id: "Projekt Listing",
      title: "Projekt Liste",
      template: ProjektListing,
      fullobjects: true,
    },
  ];

  config.blocks.blocksConfig.title.edit = NewEditTitleBlock;

  // Configuration for icon-grid block
  config.blocks.blocksConfig.icon_grid = {
    id: 'icon_grid',
    title: 'Icon Hot Bar',
    edit: IconGridEdit,
    view: IconGridView,
    icon: iconGridIcon,
    group: 'common',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  // Configuration for button-highlight block
  config.blocks.blocksConfig.button_highlight = {
    id: 'button_highlight',
    title: 'Button Highlight',
    edit: ButtonHighlightEdit,
    view: ButtonHighlightView,
    icon: ButtonHighlightIcon,
    group: 'common',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  // Configuration for sponsoren-bereich block
  config.blocks.blocksConfig.sponsoren_bereich = {
    id: 'sponsoren_bereich',
    title: 'Sponsoren Bereich',
    edit: SponsorenBereichEdit,
    view: SponsorenBereichView,
    icon: SponsorenBereichIcon,
    group: 'common',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.slider = {
    id: 'slider',
    title: 'Custom Slider',
    group: 'common',
    icon: SliderIcon,
    view: SliderView,
    edit: SliderEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  // Configuration for kontakte block
  config.blocks.blocksConfig.kontakte_block = {
    id: 'kontakte_block',
    title: 'Kontakte Block',
    edit: KontakteEdit,
    view: KontakteView,
    icon: KontakteIcon,
    group: 'common',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  // Configuration for formular block
  config.blocks.blocksConfig.formular_block = {
    id: 'formular_block',
    title: 'Formular Block',
    edit: FormularEdit,
    view: FormularView,
    icon: FormularIcon,
    group: 'common',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  // Configuration for foerderer block
  config.blocks.blocksConfig.foerderer_block = {
    id: 'foerderer_block',
    title: 'Foerderer Block',
    edit: FoerdererEdit,
    view: FoerdererView,
    icon: FoerdererIcon,
    group: 'common',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  // Configuration for calendar block
  config.blocks.blocksConfig.calendar = {
    id: 'calendar',
    title: 'Kalender Block',
    edit: CalendarEdit,
    view: CalendarView,
    icon: CalendarIcon,
    group: 'common',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  return config;
}
